import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSquare } from '@fortawesome/pro-solid-svg-icons';
// Styles
import styles from './SearchListItem.module.css';

// Utils
import cn from '../../../utils/cn';

// FontAwesome

/**
 * SearchListItem
 * @param {object} params
 * @param {number | string} params.id
 * @param {boolean} [params.isDisabled = false]
 * @param {React.ReactNode | null} [params.children = null]
 * @param {'default' | 'group'} [params.theme = 'default']
 * @param {() => void} [params.onClick = () => {}]
 * @param {boolean} [params.isSelected = false]
 * @param {string} [params.color = '']
 * @returns {JSX.Element} The SearchListItem component
 */
function SearchListItem({
  id,
  isDisabled = false,
  children = null,
  theme = 'default',
  onClick = () => {},
  isSelected = false,
  color = 'transparent',
}) {
  const hasColor = color && color !== 'transparent';
  return (
    <button
      type="button"
      key={id}
      onClick={onClick}
      className={cn([
        styles.item,
        isDisabled && styles['item-disabled'],
        theme && styles[theme],
        isSelected && styles['item-selected'],
      ])}
      tabIndex={isDisabled ? -1 : 0}
    >
      <div className={styles['item-info']}>
        <div className={styles['item-info-left']}>
          <div className={styles['item-label-container']}>
            {hasColor && (
              <FontAwesomeIcon
                icon={faSquare}
                className={styles['item-color-icon']}
                style={{ color }}
                aria-label={`Couleur: ${color}`}
              />
            )}
            {children || null}
          </div>
        </div>
      </div>
    </button>
  );
}

/**
 *
 * @param {object} params
 * @param {import('react').ReactNode} params.children
 * @returns {JSX.Element} The SearchListItemActions component
 */
export function SearchListItemActions({ children }) {
  return <div className={styles['item-actions']}>{children}</div>;
}

export default SearchListItem;
